$(document).ready(function () {
  // var swiperSlide = new Swiper('.tab-products-swiper', {
  //   //Optional parameters
  //   loop: false,
  //   slidesPerView: 3.2,
  //   spaceBetween: 24,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: "fraction",
  //   },
  //   // Navigation arrows
  //   navigation: {
  //     nextEl: '.collections-tab-next',
  //     prevEl: '.collections-tab-prev',
  //   },
  // });
  //swiperSlide.on('transitionEnd', function () {
  // swiperSlide.on('slideChange', function () {
  //   console.log('111111')
  // });

  $('.collections-tab-title .tab-title').click(function () {
    if (!$(this).hasClass('active')) {
      $('.collections-tab-title .tab-title').removeClass('active');
      $(this).closest('.collections-tab').find('.tab-products').removeClass('active');
      $(this).addClass('active');
      $(this).closest('.collections-tab').find('.tab-products').eq($(this).index()).addClass('active');
    }
  });

  // var swiperOurCollections = new Swiper('.our-collections-detail', {
  //   loop: false,
  //   slidesPerView: 1,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: "fraction",
  //   },
  //   // Navigation arrows
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  // });

  // swiperOurCollections.on('transitionEnd', function () {
  //   $('.our-collections-image .category-image').removeClass('active')
  //   $('.our-collections-image .category-image').eq(swiperOurCollections.realIndex).addClass('active');
  // });

  $('.looking-for-collections').click(function () {
    $(this).toggleClass('active')
  });

  // $('.looking-for-collections li').click(function () {
  //   $('.looking-for-collections li').removeClass('selected');
  //   $(this).addClass('selected')
  // });

  $('.looking-for-button').click(function (e) {
    e.preventDefault();
    startShoppingUrl($(this));
    // var url = '';
    // $('.looking-for-collections li').each(function (index, element) {
    //   if ($(element).hasClass('selected')) {
    //     url = $(element).data('url')
    //   }
    // });
    // if (url != '') window.location.href = url;
  });

  $('.looking-for-selected').click(function () {
    let actived = false;
    if ($(this).closest('.looking-for-item').hasClass('active')) actived = true;
    $('.looking-for-item').removeClass('active');
    if (actived) {
      $(this).closest('.looking-for-item').removeClass('active')
    } else {
      $(this).closest('.looking-for-item').addClass('active')
    }
  });

  $('.looking-for-list li').click(function () {
    if ($(this).hasClass('selected')) {
      if ($(this).data('select') != 'all') {
        $(this).closest('.looking-for-list').find('li.all').removeClass('selected');
        $(this).removeClass('selected');
      } else {
        $(this).closest('.looking-for-list').find('li').removeClass('selected');
      }
    } else {
      if ($(this).data('select') != 'all') {
        $(this).addClass('selected');
      } else {
        $(this).closest('.looking-for-list').find('li').addClass('selected');
      }
    }
    var allSelected = 1;
    $(this).closest('.looking-for-list').find('li').each(function () {
      if (!$(this).hasClass('selected') && !$(this).hasClass('all')) {
        //console.log($(this))
        allSelected = 0;
      }
    });
    //console.log('allSelected', allSelected);
    if (allSelected == 1) $(this).closest('.looking-for-list').find('li.all').addClass('selected');
  })

  var target = $(".looking-for-list, .looking-for-selected");

  $(document).on("click", function (event) {
    // Check if the clicked element is not a descendant of the target element
    if (!target.is(event.target) && !target.has(event.target).length) {
      // Clicked outside the target element
      $('.looking-for-item').removeClass('active');
    }
  });

  var show = 1;
  $('.instagram-feed-more a').click(function (e) {
    e.preventDefault();
    var countRows = $('#insta-feed .instafeed-container').length / 5 - 1;
    if (show < countRows) {
      $(this).closest('.instagram-feed-custom-container').addClass('show-' + show);
      show++;
      if (show == countRows) {
        $(this).closest('.instagram-feed-custom-container').addClass('show-end');
      }
    }
  });

  var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
      callback();
    } else {
      setTimeout(function () {
        waitForEl(selector, callback);
      }, 100);
    }
  };

  waitForEl('.collections-tab-products .wishlist', function () {
    setTimeout(function () {
      $('.collections-tab-products .wishlist button').each(function (index, element) {
        if ($(element).hasClass('swym-added')) {
          $(element).closest('.product-detail').addClass('swym-added')
        }
      })
    }, 1000)
  });

  $('.collections-tab-products .wishlist button').click(function () {
    if ($(this).hasClass('swym-added')) {
      $(this).closest('.product-detail').removeClass('swym-added')
    } else {
      $(this).closest('.product-detail').addClass('swym-added')
    }
    setTimeout(function () {
      $('.collections-tab-products .wishlist button').each(function (index, element) {
        if (!$(element).closest('.product-detail').hasClass('swym-added')) {
          $(element).removeClass('swym-added')
        }
      })
    }, 1000)
  });

  waitForEl('.listing-page .wishlist', function () {
    setTimeout(function () {
      $('.listing-page .wishlist button').each(function (index, element) {
        if ($(element).hasClass('swym-added')) {
          $(element).closest('.product--detail-wishlist').addClass('swym-added')
        }
      })
    }, 1000)
  });

  $('.product--detail-wishlist .wishlist button').click(function () {
    if ($(this).hasClass('swym-added')) {
      $(this).closest('.product--detail-wishlist').removeClass('swym-added')
    } else {
      $(this).closest('.product--detail-wishlist').addClass('swym-added')
    }
    setTimeout(function () {
      $('.listing-page .wishlist button').each(function (index, element) {
        if (!$(element).closest('.product--detail-wishlist').hasClass('swym-added')) {
          $(element).removeClass('swym-added')
        }
      })
    }, 1000)
  });
  //if(wind)
  //$('.our-collections .our-collections-info .collection-description').scrollbar();

  // var wishlistAdded = false;
  // //if($('.product--button-wishlist').hasClass('swym-added')) wishlistAdded = true;
  // waitForEl('.product--button-wishlist', function () {
  //   setTimeout(function () {
  //     if ($('.product--button-wishlist').hasClass('swym-added')) wishlistAdded = true;
  //   }, 1000)
  // });
  // $('.product--button-wishlist').click(function () {
  //   //console.log('ajks ajsdn');
  //   if (wishlistAdded) {
  //     console.log('Removed');
  //     wishlistAdded = false;
  //   } else {
  //     console.log('Added');
  //     wishlistAdded = true;
  //   }
  //   //let productId = $(this).closest('.product--details').data('product-id');
  //   //let vendorName = $(this).closest('.product--details').find('.vendor--name').data('vendor-name');
  // })
});

/**
  * Get link for Start Shopping section
  * @param productType (array), collectionUrl (array)
  * @result collectionUrl + productType
  */
function startShoppingUrl(buttonStart) {
  var productType = getSeletedValues('.looking-for-prduct-type li', 'product-type');
  var collectionUrl = getSeletedValues('.looking-for-collections li', 'product-url');
  var urlAll = jQuery(buttonStart).data('url');
  if (productType.length == 0 && collectionUrl.length == 0) {
    window.open(urlAll);
  } else {
    //When no product-type selected
    if (productType.length == 0) {
      //When no collection selected
      if (collectionUrl.length == 0) {
        window.open(urlAll);
      } else {
        //When has collection selected
        let i = 0;
        while (i < collectionUrl.length) {
          window.open(collectionUrl[i]);
          i++;
        }
      }
    } else {
      //When has product-type selected
      var url = new URL(urlAll);
      var paramsArray = [];
      var paramText = 'filter.p.product_type';
      var index = 0;
      while (index < productType.length) {
        let params = [paramText, productType[index]];
        paramsArray.push(params);
        index++;
      }

      var searchParams = new URLSearchParams(paramsArray);
      if (collectionUrl.length == 0) {
        //url.searchParams.set(paramText, productType[index]);
        let urlNew = url.toString() + '?' + searchParams.toString();
        window.open(urlNew);
      } else {
        //When has collection selected
        let i = 0;
        while (i < collectionUrl.length) {
          let url = collectionUrl[i];
          let urlNew = url.toString() + '?' + searchParams.toString();
          window.open(urlNew);
          i++;
        }
      }
    }
  }
}

function getSeletedValues(list, dataType) {
  var arraySelected = [];
  jQuery(list).each(function (index, element) {
    if (jQuery(element).hasClass('selected')) {
      let productTypeE = jQuery(element).data(dataType).trim();
      arraySelected.push(productTypeE);
    }
  });

  return arraySelected;
}
